import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Send, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';

export function ChatPage() {
  const { id } = useParams<{ id: string }>();
  
  if (!id) {
    // Conversation list
    return (
      <div className="min-h-screen pb-24">
        <header className="border-b bg-background px-4 py-4">
          <div className="mx-auto max-w-lg">
            <h1 className="font-display text-2xl font-bold">Conversas</h1>
          </div>
        </header>
        
        <main className="mx-auto max-w-lg px-4 py-6">
          {/* Empty state */}
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12 text-center">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
                <MessageCircle className="h-8 w-8 text-muted-foreground" />
              </div>
              <h2 className="font-display text-lg font-semibold">Nenhuma conversa</h2>
              <p className="mt-1 text-muted-foreground">
                Quando você iniciar uma conversa com um anfitrião ou convidado, ela aparecerá aqui.
              </p>
            </CardContent>
          </Card>
        </main>
      </div>
    );
  }
  
  // Single conversation
  return (
    <div className="flex min-h-screen flex-col pb-24">
      {/* Header */}
      <header className="sticky top-0 z-10 border-b bg-background/95 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex max-w-lg items-center gap-3">
          <Link to="/chat" className="rounded-lg p-2 hover:bg-accent">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-muted" />
            <div>
              <p className="font-semibold">Nome do Usuário</p>
              <p className="text-xs text-muted-foreground">Online</p>
            </div>
          </div>
        </div>
      </header>
      
      {/* Messages area */}
      <main className="flex-1 overflow-y-auto px-4 py-4">
        <div className="mx-auto max-w-lg">
          <p className="text-center text-sm text-muted-foreground">
            Conversa #{id}
          </p>
          {/* Messages will be rendered here */}
        </div>
      </main>
      
      {/* Input area */}
      <div className="sticky bottom-16 border-t bg-background px-4 py-3">
        <div className="mx-auto flex max-w-lg gap-2">
          <Input placeholder="Digite sua mensagem..." className="flex-1" />
          <Button size="icon">
            <Send className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}

